import { IdentificationComponent } from "./components/commonComponents/IdentificationComponent";


export class TrainVariantDoorForCheckList {
    id: number;
    name: string;
    hasCollissions: boolean;
    isSelected: boolean;
    identificationComponent: IdentificationComponent;
    isUpperDoor:boolean;
}
